export const fieldStyles = {
  style: { backgroundColor: 'transparent', boxShadow: '' },
  inputStyle: { color: '#a9bfc9', padding: '0px' },
  hintStyle: { color: '#a9bfc9', padding: '0px' },
}
